/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react'
import './index.scss'
import NavBar from '../../../components/navbar'

const tasks = [
  {
    taskDescription: 'Develop a integrify website',
    team: ' 3 frontend developers, scrum master & product owner',
    workYouDid: [
      'Worked on different components like navbar, contact',
      'Used Jest to  test  each component',
      'Used Storybook to visualize the components',
      'Used Flow for typechecking'
    ],
    tools: ['React', 'Gatsby', 'GraphQL'],
    whatILearnt: [
      `While working on a hobby project alone, all I had to do is git add, commit and push, but when I started 
       working in a team I had to learn to create branches, updating your branch with the changes in master, resolving merge conflicts etc `,
      `Gatsby, Flow, Unit testing and Storybook were new to me`,
      `Working as team`
    ],
    website: 'https://www.integrify.io/en/'
  }
]

export const Integrify = () => {
  return (
    <>
      <NavBar />
      <div className="integrify">
        {tasks.map(task => (
          <div key={task} className="integrify__work">
            <span>Task:</span>
            <p className="work__desc">{task.taskDescription}</p>
            <span>Team:</span>
            <p className="work__team">{task.team}</p>
            <span>What I did?</span>
            <ul className="work__you-did">
              {task.workYouDid.map(work => (
                <li key={work}> ==> {work}</li>
              ))}
            </ul>
            <span>What I learnt</span>
            <ul className="lessons">
              {task.whatILearnt.map(lesson => (
                <li key={lesson}>==> {lesson}</li>
              ))}
            </ul>
            <span>Tools Used</span>
            <ul className="tools__used">
              {task.tools.map(tool => (
                <li key={tool}>{tool}</li>
              ))}
            </ul>
            <span>Result:</span>{' '}
            <p>
              <a href={task.website} target="__blank">
                Interify Website
              </a>
            </p>
          </div>
        ))}
      </div>
    </>
  )
}
export default Integrify
